module.exports = __webpack_public_path__ + "img/especialista7.2c7a2aae.png";